import React from "react";

import "../../styles/BusMapModal.css";
import { useModalKeyboard } from "../../hooks/use_modal_keyboard";
import { BusMapData } from "../../types/app.types";
import { BusMapContent } from "./BusMapContent";
import { BusMapHeader } from "./BusMapHeader";

interface VedomItem {
  id: string;
  route_name?: string;
  name?: string;
  num?: string;
  date?: string;
  time?: string;
  [key: string]: any;
}

interface BusMapModalProps {
  isOpen: boolean;
  onClose: () => void;
  busMapData: BusMapData | null;
  loading: boolean;
  error: string | null;
  selectedRoute: VedomItem | null;
}

export const BusMapModal: React.FC<BusMapModalProps> = ({
  isOpen,
  onClose,
  busMapData,
  loading,
  error,
  selectedRoute,
}) => {
  useModalKeyboard(isOpen, onClose);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <BusMapHeader selectedRoute={selectedRoute} onClose={onClose} />

        <div className="modal-body">
          {loading && (
            <div className="modal-loading">
              <div className="loading-spinner"></div>
              <p>Завантаження карти місць...</p>
            </div>
          )}

          {error && (
            <div className="modal-error">
              <span className="error-icon">⚠️</span>
              <div className="error-content">
                <strong>Помилка:</strong> {error}
              </div>
            </div>
          )}

          {busMapData && !loading && (
            <BusMapContent
              busMapData={busMapData}
              routeName={selectedRoute?.name || "N/A"}
            />
          )}
        </div>

        <div className="modal-footer">
          <button className="modal-footer-button secondary" onClick={onClose}>
            Закрити
          </button>
        </div>
      </div>
    </div>
  );
};
